import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  TextField,
  Box,

} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import ReportModal from "./reportModal";
import { axiosInstance } from "../../utils/tokenSetCookie";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
// import { ro } from "intl-tel-input/i18n";
// import { da } from "intl-tel-input/i18n";

// type Day = 'Sun' | 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat';
type Day = string;

type CountByDay = Record<Day, number>;

export interface UserData {
  userId: number;
  userName: string;
  userCounts: CountByDay;
  average: number;
  total: number;
}

export interface LocationData {
  locationName: string;
  locationCounts: CountByDay;
  average: number;
  total: number;
}

export interface ClassData {
  className: string;
  classCounts: CountByDay;
  average: number;
  total: number;
  users: UserData[];
  locations: LocationData[];
}
interface ExpandableRowProps {
  row: any;
  type: "class" | "location" | "user" | "noClass";
  fromClassId?: number;
  fromNoClassId?: number;
  fromLocationId?: number;
  fromUserId?: number;
  level?: number;
  formattedTitle: string[];
  dateFilter: string;
  businessEntity: string;
  reportFilter: string;
}

interface Report {
  classIds?: string;
  locationIds?: string;
  userIds?: string;
  day?: string;
  userName?: string;
  year?: string;
  locationName?: string;
  className?: string;
  sendDate?: string;
  generatedDate?: string;
  sendType?: string;
}

// type ReportRow = ClassData | LocationData | UserData;
const ExpandableRow: React.FC<ExpandableRowProps> = ({ row, type, level = 0, formattedTitle, dateFilter,
  businessEntity,
  reportFilter }) => {
  const [open, setOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const handleClose = () => setOpenModal(false);
  const [reportData, setReportData] = useState<Report[]>([]);

  {/*const getRowStyle = () => {
    switch (type) {
      case "class":
        return { backgroundColor: "lightgreen" };
      case "location":
        return { backgroundColor: "lightcoral", };
      case "user":
        return { backgroundColor: "lightblue", };
      case "noClass":
        return { backgroundColor: "lightyellow", };
      default:
        return {};
    }
  };*/}
  const getRowStyle = () => {
    const styles: Record<string, string> = {
      class: "lightgreen",
      location: "lightcoral",
      user: "lightblue",
      noClass: "lightyellow",
    };
    return { backgroundColor: styles[type] || "white" };
  };

  const handleReport = async (
    classId: string,
    locationId: string,
    userId: string,
    day?: Day
  ) => {

    if (!day) {
      console.warn("No day provided, skipping report fetch.");
      return;
    }
    let classIds = "All";
    let locationIds = "All";
    let userIds = "All";

    if (type === "class" || type === "noClass") {
      classIds = classId;
    }

    if (type === "location") {
      classIds = classId;
      locationIds = locationId;
    }

    if (type === "user") {
      classIds = classId;
      locationIds = locationId;
      userIds = userId;
    }

    console.log("Report Parameters:", { classIds, locationIds, userIds, day });
    const formattedDay = (day || "").replace(/\s/g, ""); // Remove all spaces

    const params = new URLSearchParams({
      businessentityId: businessEntity.toString(),
      classId: classIds?.toString() || "", // Convert to string
      locationId: locationIds?.toString() || "", // Convert to string
      dateFilterType: dateFilter?.toString() || "", // Convert to string
      userId: userIds?.toString() || "", // Convert to string
      reportFilter: reportFilter?.toString() || "", // Convert to string
      dateRange: formattedDay,
    });
    console.log("Params:", params.toString());
    const data = await handleGetReport(params);

    setReportData(data);
    setOpenModal(true);
  }

  const handleGetReport = async (params: URLSearchParams) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}tracking/specificReport?${params.toString()}`
      );

      if (response.status >= 200 && response.status < 300) {
        console.log("API Response:", response.data);
        // Optionally pass this to modal
        // setReportData(response.data.data.formattedData);
        // setOpenModal(true);
        return response.data.data.formattedData;
      } else {
        console.error("API Failed:", response.status);
      }
      // Optionally pass this to modal
      // setOpenModal(true);
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err?.message ?? "Something went wrong");
    }
  };


  const handleClassReport = async (
    classId: string,
    locationId: string,
    userId: string,
    day?: Day
  ) => {
    console.log("handleClassReport", classId, locationId, userId, day);

    await handleReport(classId, locationId, userId, day);
  };

  const handleExpand = async () => {
    setOpen(!open);

    if (!hasFetched) {
      if (type === 'location') {
        await handleLocationReport(row.classId, row.locationId, row.userId, row.day);
      } else if (type === 'user') {
        await handleUserReport(row.classId, row.locationId, row.userId, row.day);
      }
      setHasFetched(true);
    }
  }

  const handleLocationReport = async (
    classId: string,
    locationId: string,
    userId: string,
    day?: Day
  ) => {
    console.log("handleLocationReport", classId, locationId, userId, day);

    await handleReport(classId, locationId, userId, day);
  };


  const handleUserReport = async (
    classId: string,
    locationId: string,
    userId: string,
    day?: Day
  ) => {
    console.log("handleUserReport", classId, locationId, userId, day);
    await handleReport(classId, locationId, userId, day);
  }


  return (
    <>

      <ReportModal open={openModal} onClose={handleClose} data={reportData} />


      {/* Main Row */}
      <TableRow sx={{ padding: "0px", cursor: "pointer", ...getRowStyle() }} onClick={handleExpand}>
        <TableCell
          sx={{
            width: "150px",
            paddingLeft: "10px",
            paddingTop: "0px",
            paddingBottom: "0px",
            height: "10px",

            // flexGrow: 0,
            // display: "flex",
            // justifyContent: open ? "space-between" : "space-around",
            // alignItems: "center",

          }}
        >
          <Box sx={{ paddingLeft: `${level * 20}px`}} onClick={(e) => {
            e.stopPropagation();
            setOpen((prev) => !prev);
          }}>
            {type !== "user" && (
              <IconButton
                size="small"
              >
                {open ? <Remove /> : <Add />}
              </IconButton>
            )}
            {row.className ?? row.locationName ?? row.userName}
          </Box>
        </TableCell>

        {/* Daily Counts Data */}
        {formattedTitle.slice(1, -2).map((day, index) => (
          <TableCell key={index} sx={{ width: "80px", textAlign: "center", }}
            onClick={() => handleClassReport(row.classId, row.locationId, row.userId, day)}
          >
            {row.userCounts?.[day] ??
              row.locationCounts?.[day] ??
              row.classCounts?.[day] ??
              row.noclassCounts?.[day] ??
              "-"}
          </TableCell>
        ))}

        <TableCell sx={{ width: "80px", textAlign: "center" }}>
          {row.total}
        </TableCell>
        <TableCell sx={{ width: "80px", textAlign: "center" }}>
          {row.average}
        </TableCell>
      </TableRow>

      {/* Expand Locations */}
      {(type === "class" || type === "noClass") && row.locations && (
        <TableRow>
          <TableCell sx={{ padding: "0px" }} colSpan={formattedTitle.length}>
            <Collapse in={open} timeout="auto" unmountOnExit >
              <Table size="small" >
                <TableBody>
                  {Object.values(row.locations).map((locationRow, idx) => (
                    <ExpandableRow
                      key={`location-${idx}`}
                      row={locationRow}
                      type="location"
                      level={level + 1}
                      formattedTitle={formattedTitle}
                      dateFilter={dateFilter}
                      businessEntity={businessEntity}
                      reportFilter={reportFilter}
                    />
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      )}

      {/* Expand Users */}
      {type === "location" &&
        row.users &&
        Object.keys(row.users).length > 0 && (
          <TableRow>
            <TableCell colSpan={formattedTitle.length} sx={{ padding: "0px", }}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Table size="small">
                  <TableBody>
                    {Object.values(row.users).map((user: any, idx: number) => (
                      <ExpandableRow
                        key={`user-${idx}`}
                        row={user}
                        type="user"
                        level={level + 2}
                        formattedTitle={formattedTitle}
                        dateFilter={dateFilter}
                        businessEntity={businessEntity}
                        reportFilter={reportFilter}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        )}
    </>
  );
};

interface ExpandableTableProps {
  data: any; // Adjust the type based on your data structure
  dateFilter: string;
  businessEntity: string;
  reportFilter: string;
}

const ExpandableTable: React.FC<ExpandableTableProps> = ({ data, dateFilter,
  businessEntity,
  reportFilter, }) => {
  console.log("Received data:", data);

  const [filters, setFilters] = useState<{ [key: string]: string }>({});

  const handleFilterChange = (key: string, value: string) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value.toLowerCase(),
    }));
  };
  const { t } = useTranslation();

  // Function to check if a row matches the filters
  const matchesFilters = (row: any) => {
    return Object.entries(filters).every(([key, value]) => {
      if (!value) return true;

      const lowerValue = value.toLowerCase();

      return (
        row.className?.toLowerCase().includes(lowerValue) || // Class
        row.locationName?.toLowerCase().includes(lowerValue) || // Location
        row.userName?.toLowerCase().includes(lowerValue) || // User
        row.userCounts?.[key]?.toString().includes(lowerValue) ||
        row.locationCounts?.[key]?.toString().includes(lowerValue) ||
        row.classCounts?.[key]?.toString().includes(lowerValue) ||
        row.noclassCounts?.[key]?.toString().includes(lowerValue) ||
        (key === "Total" && row.total?.toString().includes(lowerValue)) ||
        (key === "Average" && row.average?.toString().includes(lowerValue))
      );
    });
  };

  if (!data || !data.formattedTitle) {
    return <p>Loading...</p>;
  }

  const filteredNoClass = Object.values(data.noClass || {}).filter(
    matchesFilters
  );
  const filteredClasses = Object.values(data.class || {}).filter(
    matchesFilters
  );

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {data.formattedTitle.map((title: any, index: number) => (
              <TableCell key={index} align={index === 0 ? "left" : "center"}>
                {t(title)}
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => handleFilterChange(title, e.target.value)}
                  placeholder="Filter"
                  sx={{ mt: 1 }}
                  InputProps={{
                    inputProps: { style: { padding: "3px 10px" } },
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {/* Show "No records found" if both filteredNoClass and filteredClasses are empty */}
          {filteredNoClass.length === 0 && filteredClasses.length === 0 ? (
            <TableRow>
              <TableCell colSpan={data.formattedTitle.length} align="center">
                No records found
              </TableCell>
            </TableRow>
          ) : (
            <>
              {/* Render NoClass Rows FIRST */}
              {filteredNoClass.map((noClassRow: any, index: number) => (
                <ExpandableRow
                  key={`noClass-${index}`}
                  row={noClassRow}
                  type="noClass"
                  formattedTitle={data.formattedTitle}
                  dateFilter={dateFilter}
                  businessEntity={businessEntity}
                  reportFilter={reportFilter}
                />
              ))}

              {/* Render Class Rows */}
              {filteredClasses.map((classRow: any, index: number) => (
                <ExpandableRow
                  key={`class-${index}`}
                  row={classRow}
                  type="class"
                  formattedTitle={data.formattedTitle}
                  dateFilter={dateFilter}
                  businessEntity={businessEntity}
                  reportFilter={reportFilter}
                />
              ))}
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExpandableTable;

//Old Code With Align Mistake
// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Collapse,
//   IconButton,
//   TextField,
// } from "@mui/material";
// import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

// const ExpandableRow: React.FC<{
//   row: any;
//   type: "class" | "location" | "user" | "noClass";
//   level?: number;
//   formattedTitle: string[]; // Receiving formattedTitle as prop
// }> = ({ row, type, level = 0, formattedTitle }) => {
//   const [open, setOpen] = useState(false);

//   const getRowStyle = () => {
//     switch (type) {
//       case "class":
//         return { backgroundColor: "lightgreen" };
//       case "location":
//         return { backgroundColor: "lightcoral" };
//       case "user":
//         return { backgroundColor: "lightblue" };
//       case "noClass":
//         return { backgroundColor: "lightyellow" };
//       default:
//         return {};
//     }
//   };

//   return (
//     <>
//       {/* Main Row */}
//       <TableRow sx={{ height: "40px", cursor: "pointer", ...getRowStyle() }}>
//         <TableCell
//           sx={{
//             width: "150px",
//             textAlign: "left",
//             // padding: "6px", // Override default padding
//             // paddingLeft: `${level * 20}px`, // Indentation based on level
//           }}
//         >
//           {type !== "user" && (
//             <IconButton
//               size="small"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setOpen((prev) => !prev);
//               }}
//             >
//               {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
//             </IconButton>
//           )}
//           {row.className ?? row.locationName ?? row.userName}
//         </TableCell>

//         {/* Daily Counts Data */}
//         {formattedTitle.slice(1, -2).map((day, index) => (
//           <TableCell key={index} sx={{ width: "80px", textAlign: "center" }}>
//             {row.userCounts?.[day] ??
//               row.locationCounts?.[day] ??
//               row.classCounts?.[day] ??
//               row.noclassCounts?.[day] ??
//               "-"}
//           </TableCell>
//         ))}

//         <TableCell sx={{ width: "80px", textAlign: "center" }}>
//           {row.total}
//         </TableCell>
//         <TableCell sx={{ width: "80px", textAlign: "center" }}>
//           {row.average}
//         </TableCell>
//       </TableRow>

//       {/* Expand Locations */}
//       {(type === "class" || type === "noClass") &&
//         row.locations &&
//         Object.keys(row.locations).length > 0 && (
//           <TableRow>
//             <TableCell colSpan={formattedTitle.length} sx={{ padding: "0px" }}>
//               <Collapse in={open} timeout="auto" unmountOnExit>
//                 <Table size="small">
//                   <TableBody>
//                     {Object.values(row.locations).map(
//                       (locationRow: any, idx: number) => (
//                         <ExpandableRow
//                           key={`location-${idx}`}
//                           row={locationRow}
//                           type="location"
//                           level={level + 1}
//                           formattedTitle={formattedTitle}
//                         />
//                       )
//                     )}
//                   </TableBody>
//                 </Table>
//               </Collapse>
//             </TableCell>
//           </TableRow>
//         )}

//       {/* Expand Users */}
//       {type === "location" &&
//         row.users &&
//         Object.keys(row.users).length > 0 && (
//           <TableRow>
//             <TableCell colSpan={formattedTitle.length} sx={{ padding: "0px" }}>
//               <Collapse in={open} timeout="auto" unmountOnExit>
//                 <Table size="small">
//                   <TableBody>
//                     {Object.values(row.users).map((user: any, idx: number) => (
//                       <ExpandableRow
//                         key={`user-${idx}`}
//                         row={user}
//                         type="user"
//                         level={level + 2}
//                         formattedTitle={formattedTitle}
//                       />
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Collapse>
//             </TableCell>
//           </TableRow>
//         )}
//     </>
//   );
// };

// interface ExpandableTableProps {
//   data: any; // Adjust the type based on your data structure
// }

// const ExpandableTable: React.FC<ExpandableTableProps> = ({ data }) => {
//   console.log("Received data:", data);

//   const [filters, setFilters] = useState<{ [key: string]: string }>({});

//   const handleFilterChange = (key: string, value: string) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [key]: value.toLowerCase(),
//     }));
//   };

//   // Function to check if a row matches the filters
//   const matchesFilters = (row: any) => {
//     return Object.entries(filters).every(([key, value]) => {
//       if (!value) return true;

//       const lowerValue = value.toLowerCase();

//       return (
//         row.className?.toLowerCase().includes(lowerValue) || // Class
//         row.locationName?.toLowerCase().includes(lowerValue) || // Location
//         row.userName?.toLowerCase().includes(lowerValue) || // User
//         row.userCounts?.[key]?.toString().includes(lowerValue) ||
//         row.locationCounts?.[key]?.toString().includes(lowerValue) ||
//         row.classCounts?.[key]?.toString().includes(lowerValue) ||
//         row.noclassCounts?.[key]?.toString().includes(lowerValue) ||
//         (key === "Total" && row.total?.toString().includes(lowerValue)) ||
//         (key === "Average" && row.average?.toString().includes(lowerValue))
//       );
//     });
//   };

//   if (!data || !data.formattedTitle) {
//     return <p>Loading...</p>;
//   }

//   const filteredNoClass = Object.values(data.noClass || {}).filter(
//     matchesFilters
//   );
//   const filteredClasses = Object.values(data.class || {}).filter(
//     matchesFilters
//   );

//   return (
//     <TableContainer component={Paper}>
//       <Table>
//         <TableHead>
//           <TableRow>
//             {data.formattedTitle.map((title: any, index: number) => (
//               <TableCell
//                 key={index}
//                 align={index === 0 ? "left" : "center"} // Align first column to left, others center
//                 sx={{
//                   width: index === 0 ? "150px" : "80px",
//                   paddingLeft: index === 0 ? `${20}px` : "0px", // Match indentation for first column
//                 }}
//               >
//                 {title}
//                 <TextField
//                   size="small"
//                   variant="outlined"
//                   fullWidth
//                   onChange={(e) => handleFilterChange(title, e.target.value)}
//                   placeholder="Filter"
//                   sx={{ mt: 1 }}
//                   InputProps={{
//                     inputProps: { style: { padding: "3px 10px" } },
//                   }}
//                 />
//               </TableCell>
//             ))}
//           </TableRow>
//         </TableHead>

//         {/*
//         <TableBody>
//           Render NoClass Rows FIRST
//           {filteredNoClass.map((noClassRow: any, index: number) => (
//             <ExpandableRow
//               key={`noClass-${index}`}
//               row={noClassRow}
//               type="noClass"
//               formattedTitle={data.formattedTitle}
//             />
//           ))}

//           Render Class Rows
//           {filteredClasses.map((classRow: any, index: number) => (
//             <ExpandableRow
//               key={`class-${index}`}
//               row={classRow}
//               type="class"
//               formattedTitle={data.formattedTitle}
//             />
//           ))}
//         </TableBody> */}

//         <TableBody>
//           {/* Show "No records found" if both filteredNoClass and filteredClasses are empty */}
//           {filteredNoClass.length === 0 && filteredClasses.length === 0 ? (
//             <TableRow>
//               <TableCell colSpan={data.formattedTitle.length} align="center">
//                 No records found
//               </TableCell>
//             </TableRow>
//           ) : (
//             <>
//               {/* Render NoClass Rows FIRST */}
//               {filteredNoClass.map((noClassRow: any, index: number) => (
//                 <ExpandableRow
//                   key={`noClass-${index}`}
//                   row={noClassRow}
//                   type="noClass"
//                   formattedTitle={data.formattedTitle}
//                 />
//               ))}

//               {/* Render Class Rows */}
//               {filteredClasses.map((classRow: any, index: number) => (
//                 <ExpandableRow
//                   key={`class-${index}`}
//                   row={classRow}
//                   type="class"
//                   formattedTitle={data.formattedTitle}
//                 />
//               ))}
//             </>
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default ExpandableTable;